/* MOST: restore the French cart label if a storefront app replaces it in English.
 * Text-only correction. Purchase, stock, preorder and payment behaviour is unchanged.
 */
(function () {
  'use strict';

  function isFrench() {
    return /^fr(?:-|$)/i.test(document.documentElement.lang || '');
  }

  function start() {
    if (!isFrench() || !document.body || window.__mostFrenchCartLabelFixInitialized) return;
    window.__mostFrenchCartLabelFixInitialized = true;

    var selector = 'button[data-add-to-cart]';
    var pending = new Set();
    var frame = 0;

    function correct(button) {
      if (!isFrench() || !button.isConnected) return;
      var label = button.querySelector('[data-add-to-cart-text]');
      if (!label) return;

      // Do not overwrite preorder, sold-out, unavailable or loading labels.
      if (!/^add\s+to\s+cart$/i.test(label.textContent.trim())) return;
      label.textContent = 'Ajouter au panier';

      if (/^add\s+to\s+cart$/i.test((button.getAttribute('aria-label') || '').trim())) {
        button.setAttribute('aria-label', 'Ajouter au panier');
      }
    }

    function flush() {
      frame = 0;
      var buttons = Array.from(pending);
      pending.clear();
      buttons.forEach(correct);
    }

    function queue(button) {
      if (!button) return;
      pending.add(button);
      if (!frame) frame = window.requestAnimationFrame(flush);
    }

    function collect(node) {
      if (!node || node.nodeType !== 1) return;
      if (node.matches(selector)) queue(node);
      node.querySelectorAll(selector).forEach(queue);
    }

    document.querySelectorAll(selector).forEach(correct);

    // Observe only relevant mutations, including app updates and replaced sections.
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var element = mutation.target.nodeType === 1
          ? mutation.target
          : mutation.target.parentElement;
        if (element && element.closest) queue(element.closest(selector));
        mutation.addedNodes.forEach(collect);
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
